import { Button, Checkbox } from '@scholastic/mockingjay';
import { useState, type FormEvent } from 'react';
import redemptionWelcomeHeader from '@/assets/images/redemption-welcome-header.png';
import { useWelcomeGuide } from '@/hooks/use-welcome-guide/use-welcome-guide';
import { useAccessCodeRedemptionContext } from './AccessCodeRedemptionContext';
import { useConfirmRedemptionSubmit } from './use-confirm-redemption-submit';
import { TermsAgreementLabel } from './ConfirmRedemption';

export function FirstTimeWelcomeRedemption() {
  const [isChecked, setIsChecked] = useState(false);
  const { redemptionData } = useAccessCodeRedemptionContext();
  const { handleSubmit: submitRedemption, isPending } =
    useConfirmRedemptionSubmit();
  const { markAsSeen, markAsArchived } = useWelcomeGuide();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    markAsSeen();
    markAsArchived();
    await submitRedemption();
  };

  if (!redemptionData.product) {
    return null;
  }

  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <form onSubmit={handleSubmit} className="flex flex-col">
      <img
        src={redemptionWelcomeHeader}
        alt=""
        className="h-[70px] w-full object-cover"
      />
      <div className="flex flex-col gap-6 p-8 pb-0 text-lg text-neutral-900">
        <h2 className="text-2xl font-bold text-red-700">
          Welcome to the Scholastic Education Platform!
        </h2>
        <p>
          You have redeemed the access code for{' '}
          <strong className="font-bold">
            {redemptionData.product.productName}!
          </strong>
        </p>
        <img
          src={redemptionData.product.thumbnailUrl}
          alt={redemptionData.product.productName}
          className="h-full max-h-11 w-fit object-scale-down"
        />
        <p>
          You must accept the product terms and the individual customer
          agreement before we can continue your setup.
        </p>
        <Checkbox
          checked={isChecked}
          onCheckedChange={(checked) => setIsChecked(!!checked)}
          label={
            /* @ts-expect-error need to fix type in mockingjay */
            (<TermsAgreementLabel />) as string
          }
        />
      </div>
      <div className="flex justify-end px-8 pb-8 pt-6">
        <Button
          type="submit"
          variant="primary"
          disabled={!isChecked || isPending}
        >
          Next
        </Button>
      </div>
    </form>
  );
}
